module.exports = __webpack_public_path__ + "img/QUADUSK.ccdaad0f.png";